export function LoadingPanel({ message }: { message: string }) {
  return (
    <main className="app-shell">
      <section className="panel narrow">
        <div className="loader" aria-hidden="true" />
        <h1>{message}</h1>
        <p className="muted">The authentication state is being updated.</p>
      </section>
    </main>
  );
}
